export default "__VITE_ASSET__BEj9PQJP__"